interface NotificationBellProps {
  hasNotification?: boolean;
  size?: number;
  color?: string;
  dotColor?: string;
}

/**
 * Filled bell icon with an optional notification dot at the top-right.
 * Use `hasNotification` to toggle the dot indicator.
 */
export const NotificationBell = ({
  hasNotification = false,
  size = 20,
  color = "#3C3295",
  dotColor = "#3C3295",
}: NotificationBellProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      {/* Bell body */}
      <path
        d="M5.5 17.5h13l-1.2-1.6a3 3 0 01-.6-1.8V10a4.7 4.7 0 00-3.5-4.55V5a1.2 1.2 0 00-2.4 0v.45A4.7 4.7 0 007.3 10v4.1a3 3 0 01-.6 1.8L5.5 17.5z"
        fill={color}
      />
      {/* Bell clapper */}
      <path
        d="M10.5 19a1.5 1.5 0 003 0"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        fill={color}
      />
      {/* Notification dot */}
      {hasNotification && (
        <>
          <circle cx="18" cy="6" r="3.5" fill="white" />
          <circle cx="18" cy="6" r="2.5" fill={dotColor} />
        </>
      )}
    </svg>
  );
};
